import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShipmentBox = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "shipment-box" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 1.5,
			y: 6.75,
			width: 21,
			height: 16.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.3,7.5,19.9,1.641A1.5,1.5,0,0,0,18.526.75H5.475A1.5,1.5,0,0,0,4.1,1.641L1.7,7.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 6.75,
			x2: 12,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 14.25,
			y1: 18.75,
			x2: 18.75,
			y2: 18.75
		})
	]
});
export default SvgShipmentBox;
